import { pipe } from 'pipe-and-compose';

import capitalize from '../capitalize';
import join from '../join';
import split from '../split';
import toLower from '../toLower';

const transformPartsCase = (chars: string[]) =>
  chars.map((word: string, index: number) => {
    const fn = index === 0 ? capitalize : toLower;
    return fn(word);
  });

const unCamelCase = pipe(split(/(?=[A-Z])/), transformPartsCase, join(' '));

export default unCamelCase;
